export default function (value) {
  if (!value)
    return true;

  return String(value).length === 6;
};
